import { ExternalLink, LegacyDataTable, LegacyDataTableBody, LegacyDataTableHeader, LegacyDataTableHeaderColumn, LegacyDataTableRow, LegacyDataTableRowColumn } from "@octopusdeploy/design-system-components";
import type { Repository } from "@octopusdeploy/octopus-server-client";
import { HasGitPersistenceSettings } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import { sortBy } from "lodash";
import InternalLink from "~/components/Navigation/InternalLink";
export type VersionControlledProjectUsage = {
    ProjectName: string;
    ProjectId: string;
    ProjectSlug: string;
    SpaceId: string;
    Url: string;
    DefaultBranch: string;
    BasePath: string;
};
type VersionControlledProjectUsagesProps = {
    versionControlledProjects: VersionControlledProjectUsage[];
};
export function VersionControlledProjectUsages({ versionControlledProjects }: VersionControlledProjectUsagesProps) {
    if (!versionControlledProjects || versionControlledProjects.length === 0) {
        return null;
    }
    return (<LegacyDataTable>
            <LegacyDataTableHeader>
                <LegacyDataTableRow>
                    <LegacyDataTableHeaderColumn>Project</LegacyDataTableHeaderColumn>
                    <LegacyDataTableHeaderColumn>Repository</LegacyDataTableHeaderColumn>
                    <LegacyDataTableHeaderColumn>Default Branch</LegacyDataTableHeaderColumn>
                    <LegacyDataTableHeaderColumn>Git File Storage Directory</LegacyDataTableHeaderColumn>
                </LegacyDataTableRow>
            </LegacyDataTableHeader>
            <LegacyDataTableBody>
                {sortBy(versionControlledProjects, [(x) => x.ProjectName, "asc"]).map((usageEntry) => {
            return (<LegacyDataTableRow key={usageEntry.ProjectId}>
                            <LegacyDataTableRowColumn>
                                <InternalLink to={links.projectRootRedirect.generateUrl({ spaceId: usageEntry.SpaceId, projectSlug: usageEntry.ProjectSlug })}>{usageEntry.ProjectName}</InternalLink>
                            </LegacyDataTableRowColumn>
                            <LegacyDataTableRowColumn>
                                <ExternalLink href={usageEntry.Url}>{usageEntry.Url}</ExternalLink>
                            </LegacyDataTableRowColumn>
                            <LegacyDataTableRowColumn>
                                <code>{usageEntry.DefaultBranch}</code>
                            </LegacyDataTableRowColumn>
                            <LegacyDataTableRowColumn>
                                <code>{usageEntry.BasePath}</code>
                            </LegacyDataTableRowColumn>
                        </LegacyDataTableRow>);
        })}
            </LegacyDataTableBody>
        </LegacyDataTable>);
}
export async function getVersionControlledProjectUsages(repository: Repository): Promise<VersionControlledProjectUsage[]> {
    const allProjects = await repository.Projects.all();
    return allProjects
        .filter((project) => project.IsVersionControlled)
        .map((project) => {
        if (HasGitPersistenceSettings(project.PersistenceSettings)) {
            return {
                ProjectName: project.Name,
                ProjectId: project.Id,
                ProjectSlug: project.Slug,
                SpaceId: project.SpaceId,
                Url: project.PersistenceSettings.Url,
                DefaultBranch: project.PersistenceSettings.DefaultBranch,
                BasePath: project.PersistenceSettings.BasePath,
            };
        }
        throw new Error("Project is not version controlled");
    });
}
